<script>
    import { tooltip } from "@svelte-plugins/tooltips";
    
    import AimTooltip from '../component/AimTooltip.svelte'

    // Whether the action column should be displayed.
    export let display = true;
    
    // Icon properties - The main icon for the action, either outline or filled. An optional alert icon can be displayed if there are warnings.
    export let icon;
    export let displayFilled;
    export let displayAlert = false;
    export let alertIcon;

    // Tooltip properties - An optional tooltip can be added to the action.
    export let tooltipText = undefined;
    export let tooltipOptions = undefined;
</script>

<style>
    td.table-action {
        font-size: 14px;
        padding-top: 4px;
        padding-bottom: 0;
        text-align: center;
    }

    td.table-action button {
        padding: 1px 4px;
        color: #0267B3;
        border-radius: 5px;
    }

    td.table-action button:hover {
        background-color: #bad1e0;
    }
</style>

{#if display}
    <td class="table-action">
        <button type="button" class="button-reset focus-outline" on:click|stopPropagation>
            {#if tooltipText}
                <span class="bi-stacked" use:tooltip={{
                    content: {
                        component: AimTooltip,
                        props: tooltipText
                    },
                    ...tooltipOptions
                }}>
                    <i class="bi bi-{icon}{displayFilled ? '-fill' : ''}" />
                    {#if displayAlert}
                        <i class="bi bi-{alertIcon}-fill bi-alert" />
                    {/if}
                </span>
            {:else}
                <span class="bi-stacked">
                    <i class="bi bi-{icon}{displayFilled ? '-fill' : ''}" />
                    {#if displayAlert}
                        <i class="bi bi-{alertIcon}-fill bi-alert" />
                    {/if}
                </span>
            {/if}
        </button>
    </td>                                    
{/if}